import { styled } from '@mui/material/styles';
import MuiButton, { ButtonProps } from '@mui/material/Button';

const CustomButton = styled(MuiButton)(({}) => ({
  fontSize: '15px',
  lineHeight: '22px',
  fontWeight: 600,
  letterSpacing: '-0.1px',
  borderRadius: '6px',
  padding: '8px 12px',
  cursor: 'pointer',
  textTransform: 'none',
  boxShadow: `var(--shadow-xsm)`,
  color: 'var(--base-white)',
  fontFamily: 'Pretender',
  '&.MuiButton-containedPrimary': {
    background: 'var(--main-brand-color)',
    boxShadow: 'var(--shadow-xsm)',
    color: 'var(--base-white)',
    padding: '12px 20px',
    '&:hover': {
      background: 'var(--main-brand-color)',
    },
  },

  '&.MuiButton-containedSecondary': {
    color: 'var(--base-white)',
    backgroundColor: 'var(--blue-gradient-03)',
    boxShadow: 'var(--shadow-xsm)',
    padding: '10px 30px',
  },
  '&.MuiButton-outlined': {
    color: 'var(--blue-gradient-03)',
    backgroundColor: 'var(--base-white)',
    border: '1px solid var(--blue-gradient-03)',
    boxShadow: 'var(--shadow-xsm)',
    padding: '12px 30px',
  },
  '&.MuiButton-outlinedPrimary': {
    padding: '10px 20px',
  },
  '&.MuiButton-outlinedSecondary': {
    padding: '12px 30px',
    border: '1px solid var(--neutral-700)',
    boxShadow: 'none',
    color: '#272D37',
  },

  '&.MuiButton-text': {
    fontSize: '14px',
    lineHeight: '20px',
    color: 'var(--blue-gradient-03)',
    padding: 'unset',
    boxShadow: 'unset',
  },

  '&.Mui-disabled': {
    background: 'var(--neutral-700)',
    color: 'var(--neutral-900)',
  },
}));

interface CustomButtonProps extends ButtonProps {
  color?: 'primary' | 'secondary' | 'error';
}

export default function Button({
                                 variant = 'contained',
                                 color = 'primary',
                                 ...props
                               }: CustomButtonProps) {
  return <CustomButton variant={variant} color={color} {...props} />;
}
